import {Component, OnInit, ViewChild} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Issue } from '@models/issue.model';

import { Log } from 'ng2-logger';
import { Router } from "@angular/router";
import { IssuesService } from "@services/issues.service";
import { PermissionService } from "@app/authentication/services/permission.service";
import {ConfirmationModalComponent, LogoutModalComponent} from "@app/shared/components";
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-signal-issue',
    templateUrl: './signal-issue.component.html',
    styleUrls: ['./signal-issue.component.scss']
})
export class SignalIssueComponent implements OnInit {

    _logger = Log.create(SignalIssueComponent.name);
    @ViewChild('errorModal', {static: true}) errorModal: ConfirmationModalComponent;
    @ViewChild(LogoutModalComponent, {static: false}) logoutModal: LogoutModalComponent;

    confirmationPopupMessage: string;
    isLoading: boolean;
    readonly badgeLogoutCountdownSeconds = environment.badgeLogoutCountdownSeconds;

    constructor(private issueService: IssuesService,
                private router: Router,
                private permissionService: PermissionService,
                private translationService: TranslateService) {
    }

    ngOnInit() {
    }

    onSignalIssue(issue: Issue) {
        this.confirmationPopupMessage = '';
        this._logger.info("onSignalIssue:: Creating signalled issue");
        this.isLoading = true;
        this.issueService.signalIssue(issue).subscribe(
            (data: any) => {
                this._logger.info("onSignalIssue:: API returned data", data);
                this.confirmationPopupMessage = this.translationService.instant("lineSetter.signalIssue.confirmation.created");
                this.isLoading = false;
                this.logoutModal.open();
            },
            (error: any) => {
                if (error && error.error) {
                    this.confirmationPopupMessage = error.error.message;
                    this.errorModal.open();
                }
                this._logger.error("onSignalIssue:: API returned error", error);
                this.isLoading = false;
            }
        );
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('VIEW_ISSUES');
    }

}
